module.exports = __webpack_public_path__ + "assets/img/24_985.866bd4b1.jpg";